import { fromJS  } from 'immutable';

export const State = fromJS({
  isGetting: false,
  isDeleting: false,
  errMsg: '',
  noteIdList: [],
  notes: {}
});